export default __webpack_public_path__ + "static/partnerColorIcon3-16455f2cb94bc3ccc1acc152e68b7300.svg";